import React from "react";

type PlaylistEditTooltipProps = {
    title?: React.ReactNode;
    paragraphs?: React.ReactNode[];
    children?: React.ReactNode;
    style?: React.CSSProperties;
};

const PlaylistEditTooltip = ({ title, paragraphs = [], children, style }: PlaylistEditTooltipProps) => (
    <div style={{ textAlign: "left", ...style }}>
        {title && <div style={{ marginBottom: 5, fontWeight: "bolder" }}>{title}</div>}
        {paragraphs.map((p, i) => (
            <div key={i} style={{ marginBottom: 10 }}>{p}</div>
        ))}
        {children}
    </div>
);

export default PlaylistEditTooltip;
